import { List, Datagrid, TextField, EditButton } from 'react-admin';

export const SettingsList = () => (
  <List>
    <Datagrid>
    <TextField source="setting_name" />
      <EditButton />
    </Datagrid>
  </List>
);